import { useRef, useEffect, useState } from "react";
import SignaturePadLib from "signature_pad";
import { AppButton } from "../buttons/button";

export default function SignaturePad({ onSave, onCancel }) {
  const canvasRef = useRef(null);
  const padRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

    padRef.current = new SignaturePadLib(canvas, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)",
    });

    padRef.current.addEventListener("endStroke", () => {
      setIsEmpty(padRef.current.isEmpty());
    });

    return () => {
      if (padRef.current) padRef.current.off();
    };
  }, []);

  const handleClear = () => {
    padRef.current.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (padRef.current.isEmpty()) return;
    const dataUrl = padRef.current.toDataURL("image/png");
    onSave(dataUrl);
  };

  return (
    <div className="space-y-4">
      <div className="border-2 border-dashed border-grey-200 rounded-lg overflow-hidden bg-white">
        <canvas
          ref={canvasRef}
          className="w-full"
          style={{ height: "200px", touchAction: "none" }}
        />
      </div>
      <p className="text-xs text-grey-98 text-center">Draw your signature above</p>
      <div className="flex gap-3 justify-end">
        {onCancel && (
          <AppButton onClick={onCancel} variant="outline" fullWidth={false} className="px-6" size="sm">
            Cancel
          </AppButton>
        )}
        <AppButton onClick={handleClear} variant="outline" fullWidth={false} className="px-6" size="sm">
          Clear
        </AppButton>
        <AppButton onClick={handleSave} fullWidth={false} className="px-6" size="sm" disabled={isEmpty}>
          Sign & Accept
        </AppButton>
      </div>
    </div>
  );
}
